<template>
  <v-col cols="12" :md="columns" sm="12" xs="12">
    <v-text-field v-model="form.copier.copier_quantity" type="number" density="compact" variant="outlined"
      label="How many printers do you need?" />
  </v-col>
</template>

<script setup lang="ts">
import {computed} from "vue";
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
const columns = computed(() => {
  return form.value.copier.acquisition_type === 'lease' ? 6 : 12
});
</script>
